import { useMemo, type VoidFunctionComponent } from 'react';

import IssueListItem from '../issues/IssueListItem';
import type { IssueType } from '../../../../shared/issuesV2';
import type { Project, Revision } from '../../../types';

type Props = {
  unresolvedIssueCounts: Revision['unresolved_issue_counts'];
  project: Project;
};

/**
 * Preview content displayed when there are unresolved issues
 */
const PreviewContentFailing: VoidFunctionComponent<Props> = ({ unresolvedIssueCounts, project }) => {
  const listItems = useMemo(() => {
    return Object.entries(unresolvedIssueCounts || {})
      .filter(([, count]) => count > 0)
      .sort(([, countA], [, countB]) => countB - countA)
      .map(([issueType, count]) => (
        <IssueListItem
          key={issueType}
          issueType={issueType as IssueType}
          count={count}
          projectOrgId={project.organizationId}
        />
      ));
  }, [unresolvedIssueCounts, project.organizationId]);

  return (
    <div className="col-md-7">
      <h3 className="margin-top margin-top-responsive">Scan Details</h3>
      <ul className="project-issues-list">
        {listItems}
      </ul>
    </div>
  );
};

export default PreviewContentFailing;
